<template>
  <div class="container-pdf" :class="{ 'zoom-active': zoom < 10 }">
    <pdf v-for="i in numPages" :key="i" :page="i" :src="src"> </pdf>
  </div>
</template>

<script>
import pdf from "vue-pdf";

export default {
  props: ["pdfDoc"],
  components: {
    pdf,
  },
  data() {
    return {
      numPages: undefined,
      currentPage: 1,
      loadedRatio: 0,
      page: 1,
      rotate: 0,
      show: true,
      pageCurrent: 0,
      pageLabel: "1",
      disableNext: false,
      disablePrev: true,
      src: null,
      zoom: 100,
    };
  },
  mounted() {
    this.src = pdf.createLoadingTask(`${this.pdfDoc}`);
    this.src.promise.then((pdf) => (this.numPages = pdf.numPages));
  },
  methods: {
    next() {
      this.currentPage += 1;
      this.currentPage =
        this.currentPage >= this.numPages ? this.numPages : this.currentPage;
      this.disableNext = this.currentPage >= this.numPages;
      this.disablePrev = this.currentPage <= 1;
    },
    change() {
      this.disableNext = this.currentPage >= this.numPages;
      this.disablePrev = this.currentPage <= 1;
    },
    previous() {
      this.currentPage -= 1;
      this.currentPage = this.currentPage <= 1 ? 1 : this.currentPage;
      this.disablePrev = this.currentPage <= 1;
      this.disableNext = this.currentPage >= this.numPages;
    },
    numberPages() {
      const pages = [];
      for (let index = 0; index < this.numPages; index++) {
        pages.push({ index: index + 1, label: index + 1 });
      }
      return pages;
    },
  },
};
</script>

<style lang="scss">
.container-pdf {
  height: 100vh;
  overflow-y: scroll;
  // border-radius: 35px !important;
  &.zoom-active {
    cursor: grab;
  }
  /*& {
        scrollbar-width: thin;
        scrollbar-color: #3a8fce transparent;
    }

    &::-webkit-scrollbar {
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        background: #d9d9d9;
        border-radius: 25px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: #e97c21;
        border-radius: 25px;
    }*/
}
</style>
